import { ZfpLogo, colorScales, colors } from "@zfp-akademie-a-s/zfp-design";
import { PdfPrintFragment } from "Components/PdfTemplate/PdfPrintFragment";
import { PDF_BODY_FONT_FAMILY } from "Components/PdfTemplate/PdfTemplateTheme";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { format } from "date-fns";

const SeparatorArrow = () => (
  <svg
    viewBox="0 0 20 20"
    style={{ height: 20, width: 20, display: "inline-flex", alignSelf: "center" }}
    role="presentation"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon
      points="4.59,16.59 6,18 14,10 6,2 4.59,3.41 11.17,10"
      fill={colors.brandPrimary}
      stroke={colors.white}
      strokeWidth={1}
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

export const PdfTemplateHeader = () => {
  const { t } = useResource();

  return (
    <PdfPrintFragment>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "92%",
          margin: "0 auto",
          padding: "8px 0",
          borderBottom: `2px solid ${colorScales.gray[500]}`,
          fontFamily: PDF_BODY_FONT_FAMILY,
          fontSize: 14,
          lineHeight: 1.3,
          color: colors.textSecondary,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          {/* the print header keeps no stylesheet, so the logo's size goes inline; its colours are attributes */}
          <ZfpLogo height={25} style={{ display: "block", height: 25, width: 48, flexShrink: 0 }} />

          <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
            <span style={{ fontWeight: 700 }}>{t(Resources.PdfTemplate.Header.Title)}</span>
            <SeparatorArrow />
            <span style={{ fontWeight: 300 }}>{t(Resources.PdfTemplate.Header.Questionnaire)}</span>
          </div>
        </div>

        <span style={{ fontWeight: 300 }}>{format(new Date(), "d. M. yyyy")}</span>
      </div>
    </PdfPrintFragment>
  );
};
